import React from "react";

import "./VersionCount.scss";
import { APP_VERSION } from "../../../constants/appVersion";

export const VersionCount = () => (
    <div className={"version-count"}>v.{APP_VERSION}</div>
);
